import { Button } from '@/components/ui/button';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  // Detect chunk loading errors (stale chunks after deployment)
  const isChunkError = error.message.includes('Failed to fetch dynamically imported module');

  if (isChunkError) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen gap-4">
        <p className="text-muted-foreground">New version available. Please reload.</p>
        <Button onClick={() => window.location.reload()}>Reload</Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4">
      <p className="text-muted-foreground">Failed to load page. Please try refreshing.</p>
      <Button onClick={resetErrorBoundary}>Retry</Button>
    </div>
  );
}
